import {Link} from "react-router-dom";
import {AlertTriangle, ArrowRight, Clock3, Workflow} from "lucide-react";
import type {AdminSymphonyaDashboard} from "@zaaaz/shared";
import {Button} from "@/components/ui/button";
import {AdminCard} from "./ui";

type Props = {
  data: AdminSymphonyaDashboard | null;
};

export function SymphonyaSummaryCard({data}: Props) {
  const k = data?.kpis;
  return (
    <AdminCard
      title="Symphonya"
      description="ERP sync snapshot — open Integrations for full controls and logs."
      actions={
        <Button variant="outline" size="sm" asChild>
          <Link to="/vadmin/integrari">
            Open Integrations <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      }
    >
      {!data || !k ? (
        <p className="text-sm text-muted-foreground">Loading Symphonya summary…</p>
      ) : (
        <div className="admin-sym-summary">
          <div className="admin-sym-summary__kpis">
            <div className="admin-sym-summary__kpi">
              <Clock3 className="h-4 w-4 text-amber-600" />
              <div>
                <p className="admin-sym-summary__label">Pending</p>
                <p className="admin-sym-summary__value">{k.pending}</p>
                <p className="admin-sym-summary__hint">{k.pendingToday} today</p>
              </div>
            </div>
            <div className="admin-sym-summary__kpi">
              <AlertTriangle className="h-4 w-4 text-rose-600" />
              <div>
                <p className="admin-sym-summary__label">Errors</p>
                <p className="admin-sym-summary__value">{k.errors}</p>
                <p className="admin-sym-summary__hint">{k.errorsToday} today</p>
              </div>
            </div>
            <div className="admin-sym-summary__kpi">
              <Workflow className="h-4 w-4 text-sky-600" />
              <div>
                <p className="admin-sym-summary__label">Synced</p>
                <p className="admin-sym-summary__value">{k.synced}</p>
                <p className="admin-sym-summary__hint">ERP id set</p>
              </div>
            </div>
          </div>
          <div className="admin-sym-summary__meta">
            <p>
              <span className="text-muted-foreground">Last product sync:</span>{" "}
              {data.lastProductSync ? <strong>{data.lastProductSync.at}</strong> : <em>None yet</em>}
            </p>
            <p>
              <span className="text-muted-foreground">Last order push:</span>{" "}
              {data.lastOrderPush ? <strong>{data.lastOrderPush.at}</strong> : <em>None yet</em>}
            </p>
          </div>
        </div>
      )}
    </AdminCard>
  );
}
